const AppHeader = ({ onToggleSidebar, onOpenMenu }) => (
  <header className="flex items-center justify-between px-8 py-6 border-b border-color bg-primary">
    <button
      data-testid="toggle-sidebar-btn"
      onClick={onToggleSidebar}
      className="p-2 hover:bg-secondary rounded-xl transition-all"
    >
      <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>

    <div className="flex items-center space-x-4">
      <div className="avatar-orb breathing" />
      <h1 className="text-2xl font-serif text-primary font-light tracking-tight">present</h1>
    </div>

    <button
      onClick={onOpenMenu}
      className="p-2 hover:bg-secondary rounded-xl transition-all"
      data-testid="open-menu-btn"
    >
      <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
      </svg>
    </button>
  </header>
);

export default AppHeader;
